import React from 'react';

import './multiSelectControlButtons.scss';

import PropTypes from 'prop-types';
import {Button} from '../../../../../../@elixir/components';

export class MultiSelectControlButtons extends React.Component {

    static contextTypes = {
        onTakeAction: PropTypes.func,
        onCancel: PropTypes.func,
        selectedAction: PropTypes.object,
        selectionCount: PropTypes.number,
        translator: PropTypes.func
    };

    constructor (props) {
        super(props);
    }

    render () {
        const {
            onTakeAction,
            onCancel,
            selectedAction,
            selectionCount
        } = this.props;

        return (
            <div className="multiSelectControlButtonsComponent ">
                <a className="cancelButton"
                   onClick={onCancel}><span>Cancel</span></a>

                <Button className="takeActionButton"
                        disabled={selectionCount === 0}
                        name="takeActionButton"
                        type="neutral"
                        size="small"
                        onClick={onTakeAction}>
                    <span>{selectedAction.actionLabel}</span>
                </Button>
            </div>
        );
    }
}

